import axios from "axios"
import { env } from "./env"

const apiBaseURL = env.REACT_APP_BASE_URL

export const api = axios.create({
  baseURL: apiBaseURL,
  withCredentials: true,
})

export const authorizedInstance = api
export const publicInstance = api

export const SESSION_EXPIRED_EVENT = "sessionExpired"

const REFRESH_SKIP = [
  "/auth/me",
  "/auth/login",
  "/auth/token/refresh",
  "/auth/logout",
]

const shouldSkipRefresh = (url = "") =>
  REFRESH_SKIP.some((path) => url.endsWith(path))

let isRefreshing = false
let waiters = []

const flushWaiters = (error) => {
  const queued = waiters
  waiters = []
  queued.forEach(({ resolve, reject }) => {
    if (error) reject(error)
    else resolve()
  })
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config
    const status = error.response?.status

    if (
      status !== 401 ||
      !original ||
      original._retried ||
      shouldSkipRefresh(original.url)
    ) {
      return Promise.reject(error)
    }

    original._retried = true

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        waiters.push({
          resolve: () => resolve(api(original)),
          reject,
        })
      })
    }

    isRefreshing = true
    try {
      await api.post("/auth/token/refresh")
      flushWaiters(null)
      return api(original)
    } catch (refreshError) {
      flushWaiters(refreshError)
      window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT))
      return Promise.reject(refreshError)
    } finally {
      isRefreshing = false
    }
  }
)
